import $ from 'jquery';
global.vigi = {};
document.addEventListener("DOMContentLoaded", function () {
  vigi.filters.init();
});
vigi.filters = {
  ajaxCall: null,
  init: function init() {
    if ($('#js-form-filters').length > 0) {
      vigi.filters.listeners();
    }
  },
  listeners: function listeners() {
    $('.js-filters-select').on('change', function (e) {
      vigi.filters.returnFiltersValues();
    });
    $('.js-pagination').on('click', '.js-pagination-index', function (e) {
      var target = e.target;
      if (!target.closest('.js-pagination-index').classList.contains('active')) {
        vigi.filters.returnFiltersValues(target.dataset.page);
      }
    });
  },
  returnFiltersValues: function returnFiltersValues() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var data = {};
    var form = document.querySelector('#js-form-filters');
    data.typePost = form.dataset.type;
    var filters = document.querySelectorAll('.js-filters-select');
    filters.forEach(function (currentValue) {
      data[currentValue.dataset.field] = currentValue.value;
    });
    data.numPage = page;
    vigi.filters.getPostAjax(data);
  },
  changeParametersUrl: function changeParametersUrl(data) {
    //remove useless keys
    delete data.action;
    delete data.typePost;
    delete data.undefined;
    var newSearch = "?";
    Object.entries(data).forEach(function (currentValue, index) {
      var key = currentValue[0];
      var val = currentValue[1];
      if (val == "" || key == "numPage" && val == 1) {} else {
        if (newSearch.length > 1) {
          newSearch += "&";
        }
        newSearch += key + "=" + val;
      }
    });
    if (newSearch.length == 1) {
      newSearch = "";
    }
    var newUrl = window.location.origin + window.location.pathname + newSearch;
    window.history.pushState({
      path: newUrl
    }, "", newUrl);
  },
  getPostAjax: function getPostAjax(data) {
    data.action = "senegal_return_post_detail_from_filters";
    if (vigi.filters.ajaxCall && vigi.filters.ajaxCall.done && vigi.filters.ajaxCall.fail && vigi.filters.ajaxCall.always) {
      vigi.filters.ajaxCall.abort();
      vigi.filters.ajaxCall = null;
    }
    vigi.filters.ajaxCall = $.ajax({
      type: "POST",
      dataType: "json",
      url: jssettings.url,
      data: data,
      success: function success(response) {
        // console.log(response);
        vigi.filters.ajaxCall = null;
        if (response['isValid']) {
          // console.log(response['result']);
          // console.log(response['result'].length > 0);
          var containerPost = document.querySelector('.js-container-filters-post');
          var containerPagination = document.querySelector('.js-pagination');
          // console.log(containerPost);
          if (response['result'].length > 0) {
            containerPost.innerHTML = response['result'];
          } else {
            containerPost.innerHTML = "<p>" + containerPost.dataset.empty + "</p>";
          }
          containerPagination.innerHTML = response['pagination'];
          vigi.filters.changeParametersUrl(data);
        } else {
          location.reload();
        }
      },
      error: function error() {
        console.log('There was some error performing the AJAX call!');
      }
    });
  }
};
vigi.map = {
  mapPosition: {
    lat: 14.7441924,
    lng: -17.51852
  },
  mapZoom: 16,
  map: null,
  markers: {},
  infowindow: null,
  ajaxCall: null,
  init: function init() {
    vigi.map.map = new google.maps.Map(document.getElementById("gmap"), {
      zoom: vigi.map.mapZoom,
      center: vigi.map.mapPosition
    });
    vigi.infowindow = new google.maps.InfoWindow();
    vigi.map.addMarkers($("#gmap"));
  },
  addMarkers: function addMarkers(mapContainer) {
    var projectsJson = mapContainer.data('projects');
    var svgMarker = {
      path: 'M44.9,22.4L44.9,22.4c0-0.3,0-0.6,0-0.9C44.9,9.6,34.9,0,22.5,0C10.1-0.1,0,9.5,0,21.3c0,0.3,0,0.6,0,0.9l0,0c0,0,0,0.2,0.1,0.6c0.2,2.8,1,5.6,2.3,8.1c1.1,2.5,2.6,4.8,4.4,6.8c6.3,7,11,14.3,12.3,18.6c1.6,5.5,1.8,6.4,3.2,6.4c0,0,0,0,0.1,0c1.5,0,1.5-0.9,3.2-6.4c1.3-4.3,6-11.6,12.3-18.6c1.9-2.1,3.3-4.4,4.4-6.8c1.3-2.5,2.1-5.3,2.4-8.1C44.9,22.6,44.9,22.4,44.9,22.4',
      fillColor: "#E94C39",
      fillOpacity: 1,
      strokeWeight: 0,
      scaledSize: new google.maps.Size(60, 60),
      anchor: new google.maps.Point(30, 60),
      labelOrigin: new google.maps.Point(30, 80)
    };

    // Add some markers to the map.
    vigi.map.markers = projectsJson.map(function (project, i) {
      var infos = {
        id: project.id,
        name: project.name
      };
      var latlng = new google.maps.LatLng(project.latitude, project.longitude);
      var marker = new google.maps.Marker({
        position: latlng,
        infos: infos,
        title: infos.name,
        map: vigi.map.map,
        icon: svgMarker,
        label: {
          color: "#FFFFFF",
          fontWeight: 'bold',
          text: infos.name,
          className: 'marker-text'
        }
      });
      google.maps.event.addListener(marker, 'click', function (marker, i) {
        return function () {
          vigi.map.showPanel(marker);

          // Check when the close control [X] is clicked in the InfoBox
          // Note : An InfoBox behaves like a google.maps.InfoWindow
          // google.maps.event.addListener(markers[key]['infoBox'], 'closeclick', function (e) {
          //     // resetListView();
          // });
        };
      }(marker, i));
      return marker;
    });
  },
  showPanel: function showPanel(marker) {
    var data = {};
    data.action = "senegal_return_markers_detail";
    data.project = marker.infos.id;
    if (vigi.map.ajaxCall && vigi.map.ajaxCall.done && vigi.map.ajaxCall.fail && vigi.map.ajaxCall.always) {
      vigi.map.ajaxCall.abort();
      vigi.map.ajaxCall = null;
    }
    if (vigi.map.infowindow != null) {
      vigi.map.infowindow.close();
    }
    vigi.map.ajaxCall = $.ajax({
      type: "POST",
      dataType: "json",
      url: jssettings.url,
      data: data,
      success: function success(response) {
        vigi.map.ajaxCall = null;
        if (response['isValid'] && response['result'].length > 0) {
          vigi.map.infowindow = new google.maps.InfoWindow({
            content: response['result'],
            maxHeight: 300,
            maxWidth: 300,
            minWidth: 252
          });

          //this.infowindow.setContent(html);
          vigi.map.infowindow.open(vigi.map.map, marker);
        } else {
          location.reload();
        }
      },
      error: function error() {
        console.log('There was some error performing the AJAX call!');
      }
    });
  }
};